import { Observable, of } from 'rxjs';
import {
  CreateNavItem,
  IconType,
  IoniconsOutline,
  NavItem,
  NavItemsId,
  NavItemsType,
  PtPermissions
} from '@pt/pt-models';

export class NavUtils {

  static button(
    id: NavItemsId,
    label?: Observable<string>,
    faIcon?: string,
    image?: Observable<string>,
    routerLink?: string,
    enabled?: PtPermissions[],
    visible?: PtPermissions[],
    classCss?: string[],
    disabled?: Observable<boolean>,
    children?: NavItem[]
  ): NavItem {
    return {
      id,
      type: NavItemsType.BUTTON,
      label,
      icon: {
        key: faIcon,
        type: IconType.IONIC_ICON
      },
      image,
      permissEnabled: enabled,
      permissVisible: visible,
      classCss: classCss ? classCss : ['btn-success btn-sm'],
      routerLink,
      routerLinkOpt: null,
      disabled: disabled ? disabled : of(false),
      children: children
    };
  }

  static buttonDelete(
    label?: Observable<string>,
    disabled?: Observable<boolean>,
    routerLink: string = null,
    enabled: PtPermissions[] = [],
    visible: PtPermissions[] = [],
    classCss?: string[]
  ): NavItem {
    return {
      id: NavItemsId.DELETE_BUTTON,
      type: NavItemsType.BUTTON,
      label,
      icon: {
        key: IoniconsOutline.trash,
        type: IconType.IONIC_ICON
      },
      permissEnabled: enabled,
      permissVisible: visible,
      classCss: classCss ? classCss : ['btn-outline-danger btn-sm'],
      routerLink,
      routerLinkOpt: null,
      disabled: disabled ? disabled : of(false)
    };
  }

  static buttonCreate(
    label?: Observable<string>,
    routerLink: string = null,
    enabled: PtPermissions[] = [],
    visible: PtPermissions[] = [],
    classCss?: string[]
  ): NavItem {
    return {
      id: NavItemsId.CREATE_BUTTON,
      type: NavItemsType.BUTTON,
      label,
      icon: {
        key: IoniconsOutline.plus,
        type: IconType.IONIC_ICON
      },
      permissEnabled: enabled,
      permissVisible: visible,
      classCss: classCss ? classCss : ['btn-success btn-sm'],
      routerLink,
      routerLinkOpt: null,
      disabled: of(false)
    };
  }

  static buttonDownload(
    label?: Observable<string>,
    disabled?: Observable<boolean>,
    routerLink: string = null,
    enabled: PtPermissions[] = [],
    visible: PtPermissions[] = [],
    classCss?: string[]
  ): NavItem {
    return {
      id: NavItemsId.DOWNLOAD,
      type: NavItemsType.BUTTON,
      label,
      icon: {
        key: IoniconsOutline.download,
        type: IconType.IONIC_ICON
      },
      permissEnabled: enabled,
      permissVisible: visible,
      classCss: classCss ? classCss : ['btn', 'btn-info', 'btn-sm'],
      routerLink,
      routerLinkOpt: null,
      disabled: disabled ? disabled : of(false)
    };
  }

  static buttonReset(
    label: Observable<string> = of(null),
    routerLink: string = null,
    enabled: PtPermissions[] = [],
    visible: PtPermissions[] = [],
    classCss: string[] = ['pt-btn-reload btn-sm']
  ): NavItem {
    return {
      id: NavItemsId.RESET,
      type: NavItemsType.BUTTON,
      label,
      // icon: {
      //   key: IoniconsOutline.reload,
      //   type: IconType.IONIC_ICON
      // },
      permissEnabled: enabled,
      permissVisible: visible,
      classCss,
      routerLink,
      routerLinkOpt: null,
      disabled: of(false)
    };
  }

  static buttonSave(
    label: Observable<string> = of(null),
    routerLink: string = null,
    enabled: PtPermissions[] = [],
    visible: PtPermissions[] = [],
    classCss: string[] = ['pt-btn-save btn-sm btn-primary']
  ): NavItem {
    return {
      id: NavItemsId.SAVE,
      type: NavItemsType.BUTTON,
      label,
      icon: {
        key: IoniconsOutline.save,
        type: IconType.IONIC_ICON
      },
      permissEnabled: enabled,
      permissVisible: visible,
      classCss,
      routerLink,
      routerLinkOpt: null,
      disabled: of(false)
    };
  }

  static buttonObsolete(
    label: Observable<string> = of(null),
    routerLink: string = null,
    enabled: PtPermissions[] = [],
    visible: PtPermissions[] = [],
    classCss: string[] = ['btn-sm btn-link']
  ): NavItem {
    return {
      id: NavItemsId.OBSOLETE,
      type: NavItemsType.BUTTON,
      label,
      // icon: {
      //   key: IoniconsOutline.hourglass,
      //   type: IconType.IONIC_ICON
      // },
      permissEnabled: enabled,
      permissVisible: visible,
      classCss,
      routerLink,
      routerLinkOpt: null,
      disabled: of(false)
    };
  }

  static buttonReload(
    label: Observable<string> = of(null),
    routerLink: string = null,
    enabled: PtPermissions[] = [],
    visible: PtPermissions[] = [],
    classCss: string[] = ['pt-btn-reload btn-sm']
  ): NavItem {
    return {
      id: NavItemsId.RELOAD_BUTTON,
      type: NavItemsType.BUTTON,
      label,
      icon: {
        key: IoniconsOutline.reload,
        type: IconType.IONIC_ICON
      },
      permissEnabled: enabled,
      permissVisible: visible,
      classCss,
      routerLink,
      routerLinkOpt: null,
      disabled: of(false)
    };
  }


  static buttonExportWithRaw(exportLabel?: Observable<string>,
                             exportRawLabel?: Observable<string>,
                             exportTableLabel?: Observable<string>,
                             routerLink: string = null,
                             enabled: PtPermissions[] = [],
                             visible: PtPermissions[] = [],
                             classCss?: string[]
  ): NavItem {
    return {
      id: NavItemsId.EXPORT_TABLE_BUTTON,
      type: NavItemsType.MENU,
      label: exportLabel,
      icon: {
        key: IoniconsOutline.download,
        type: IconType.IONIC_ICON
      },
      permissEnabled: enabled,
      permissVisible: visible,
      classCss: classCss ? classCss : ['pt-btn-upload btn-sm'],
      routerLink,
      routerLinkOpt: null,
      disabled: of(false),
      children: [
        {
          id: NavItemsId.EXPORT_RAW_BUTTON,
          type: NavItemsType.BUTTON,
          label: exportRawLabel,
          permissEnabled: enabled,
          permissVisible: visible,
          disabled: of(false)
        },
        {
          id: NavItemsId.EXPORT_TABLE_BUTTON,
          type: NavItemsType.BUTTON,
          label: exportTableLabel,
          permissEnabled: enabled,
          permissVisible: visible,
          disabled: of(false)
        }
      ]
    };
  }

  static buttonExport(
    label?: Observable<string>,
    routerLink: string = null,
    enabled: PtPermissions[] = [],
    visible: PtPermissions[] = [],
    classCss?: string[]
  ): NavItem {
    return {
      id: NavItemsId.EXPORT_TABLE_BUTTON,
      type: NavItemsType.BUTTON,
      label,
      icon: {
        key: IoniconsOutline.download,
        type: IconType.IONIC_ICON
      },
      permissEnabled: enabled,
      permissVisible: visible,
      classCss: classCss ? classCss : ['pt-btn-upload btn-sm'],
      routerLink,
      routerLinkOpt: null, //todo
      disabled: of(false)
    };
  }

  static buttonUpload(
    label: Observable<string> = of(null),
    routerLink: string = null,
    enabled: PtPermissions[] = [],
    visible: PtPermissions[] = [],
    classCss: string[] = ['btn-sm', 'pt-btn-upload']
  ): NavItem {
    return {
      id: NavItemsId.IMPORT_BUTTON,
      type: NavItemsType.BUTTON,
      label,
      icon: {
        key: IoniconsOutline.upload,
        type: IconType.IONIC_ICON
      },
      permissEnabled: enabled,
      permissVisible: visible,
      classCss,
      routerLink,
      disabled: of(false)
    };
  }

  static create(navItem: CreateNavItem): NavItem {
    return {
      id: navItem.id,
      type: navItem.type,
      label: navItem.label,
      icon: navItem.icon,
      data: navItem.data,
      image: navItem.image,
      children: navItem.children,
      classCss: navItem.classCss,
      disabled: navItem.disabled,
      routerLink: navItem.routerLink,
      permissEnabled: navItem.enabled,
      permissVisible: navItem.visible,
      routerLinkOpt: navItem.routerLinkOpt,
      tooltipEnabled: navItem.tooltipEnabled
    };
  }

  static createLogo(id: NavItemsId | string,
                    label?: Observable<string>,
                    faIcon?: string,
                    image?: Observable<string>,
                    routerLink?: string): NavItem {
    return {
      id,
      type: NavItemsType.LOGO,
      label,
      icon: {
        key: faIcon,
        type: IconType.IONIC_ICON
      },
      permissEnabled: [],
      permissVisible: [],
      image,
      routerLink,
      routerLinkOpt: null,//todo
      disabled: of(false)
    };
  }

  static createLinkSeparator(id: NavItemsId | string, label?: Observable<string>): NavItem {
    return {
      id,
      type: NavItemsType.LINK_SEPARATOR,
      label,
      permissEnabled: [],
      permissVisible: [],
      disabled: of(false)
    };
  }

  static createLink(
    id: NavItemsId | string,
    label?: Observable<string>,
    faIcon?: string,
    enabled?: PtPermissions[],
    visibled?: PtPermissions[],
    routerLink?: string,
    tooltipEnabled?: boolean,
    classCss?: string[],
    isBetaEnabled?: boolean,
  ): NavItem {
    return {
      id,
      type: NavItemsType.LINK,
      label,
      icon: {
        key: faIcon,
        type: IconType.IONIC_ICON
      },
      permissEnabled: enabled,
      permissVisible: visibled,
      routerLink,
      routerLinkOpt: null,//todo
      tooltipEnabled,
      classCss,
      isBetaEnabled,
      disabled: of(false)
    };
  }

  static createMenu(
    id: NavItemsId | string,
    label?: Observable<string>,
    faIcon?: string,
    enabled?: PtPermissions[],
    visible?: PtPermissions[],
    children?: NavItem[],
    routerLink?: string,
    data?: any,
    classCss?: string[]
  ): NavItem {
    return {
      id,
      type: NavItemsType.MENU,
      label,
      icon: {
        key: faIcon,
        type: IconType.IONIC_ICON
      },
      permissEnabled: enabled,
      permissVisible: visible,
      children,
      routerLink,
      routerLinkOpt: null,
      data,
      classCss,
      disabled: of(false)
    };
  }
}
